const useExecuteScroll = (accordionRef) => {
  accordionRef?.current?.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });

  setTimeout(() => {
    window.scrollBy(0, -70);
  }, 500);
};

export default useExecuteScroll;
